var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardPayments = function SvgCardPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-4 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.968 9.796h1.064V2.77H6.07v1.064h4.899v5.963Zm0 1.065v2.236c0 .294-.24.533-.537.533H2.772a.53.53 0 0 1-.536-.533l.002-8.731c0-.294.24-.533.536-.533h2.23V2.236a.532.532 0 0 1 .533-.532h7.028a.533.533 0 0 1 .532.532v8.093a.533.533 0 0 1-.532.532h-1.597ZM3.303 4.898 3.3 12.565h6.602V4.898h-6.6Zm1.702 4.898H7.4a.266.266 0 0 0 0-.532H5.803a1.331 1.331 0 0 1 0-2.662h.266v-.533h1.065v.533H8.2v1.065H5.803a.266.266 0 1 0 0 .532H7.4a1.331 1.331 0 0 1 0 2.662h-.266v.532H6.07v-.532H5.005V9.796Z",
    fill: "#1D1737"
  })));
};
export default SvgCardPayments;